import { render, staticRenderFns } from "./TypeOfProject.vue?vue&type=template&id=f090a8ec"
import script from "./TypeOfProject.vue?vue&type=script&lang=js"
export * from "./TypeOfProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports